import PhoneNumberInput from '../../PhoneNumberInput/PhoneNumberInput';
import { AnswerFreeTextProps } from './AnswerFreeText';
import { FC } from 'react';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { View } from 'react-native';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { isWeb } from '../../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { useOnMount } from '../../../hooks/useOnMount';
import { useStores } from '../../../hooks/useStores';


interface IPhoneNumberQuestion extends IQuestionModel {
  type: 'freeText';
  key: 'videoCallPhoneNumber';
}

export const isPhoneNumberQuestion = (question?: IQuestionModel): question is IPhoneNumberQuestion =>
  question?.key === 'videocallPhoneNumber' &&  question?.type === 'freeText';

export const isPhoneNumberValid = (phoneNumber: string): boolean => {
  return isValidPhoneNumber(phoneNumber);
};

const AnswerPhoneNumber : FC<AnswerFreeTextProps> = (({
  question,
}) => {
  const { user, treeNav } = useStores();
  const questionId = question._id;
  const questionKey = question.key;
  const choices = treeNav.choices.pending;
  const value = choices ? choices.freeText : undefined;

  useOnMount(() => {
    if (user?.phoneNumber) {
      treeNav.choices.setPending({
        questionId,
        questionKey,
        freeText: user.phoneNumber,
      });
    }
  });

  const onChangePhoneNumber = (value: string) => {
    treeNav.choices.setPending({
      questionId,
      questionKey,
      freeText: value,
    });
    const valid = isPhoneNumberValid(value);
    if (valid) {
      user.setPhoneNumber(value);
    }
  };

  // No ScrollView here. ContentFrame already wraps every question in a
  // KeyboardAvoidingView + ScrollView (contentContainerStyle: { flexGrow: 1 }),
  // and the session's Continue button is a SIBLING inside that same scroll view.
  // Nesting a second ScrollView with no bounded height made iOS measure it far
  // taller than its one input, which inflated the outer scroll content: the
  // button was pushed down into the middle of the page behind a blank region and
  // only appeared after scrolling. Every other answer component (see
  // AnswerFreeTextGeneric) uses plain Views for exactly this reason.
  return (
    <View
      style={[{
        gap: 16,
        marginBottom: 10,
        justifyContent: 'center',
      },
      isWeb && { alignItems: 'center' }]}
    >
      <PhoneNumberInput
        value={value || ''}
        onChange={onChangePhoneNumber}
      />
    </View>
  );
});
export default observer(AnswerPhoneNumber);
